import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { animated, useSpring, useChain } from 'react-spring';

import PodiumCard from './PodiumCard';

const PodiumWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  padding: ${(props) => (props.activeBoards >= 2 ? '0px' : '0px 67px')};
  align-items: flex-end;
  flex-shrink: 0; /* Fix for Safari flex box wrong height issue */
  .accent-container {
    height: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: absolute;
    top: -30px;
    overflow: hidden;
  }

  :first-child {
    margin-left: 0px!important;
  }
  :last-child {
    margin-right: 0px!important;
  }

  .podium-card {
    width: 100%!important;
  }

  .podium-wrapper {
    position: relative;
  }
  .firstAnimatedPodium {
    order: 2;
  }

  .secondAnimatedPodium {
    order: 1
  }

  .thirdAnimatedPodium {
    order: 3
  }

  @media screen and (max-width: 991px) {
    padding: 0px!important;

    .result {
      font-size: 24px;
    }
  }
`;

const defaultPodiumStyles = {
  width: '100%',
  margin: '0px 10px',
};

const minimizedPodiumStyles = {
  width: '100%',
};

const MultiplePodiums = ({
  activeBoards,
  leaderboardData,
  windowSize,
}) => {
  const [data, setData] = useState([]);

  const firstPodiumRef = useRef();
  const firstAnimatedPodium = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    ref: firstPodiumRef,
  });

  const accentRef = useRef();

  const secondPodiumRef = useRef();
  const secondAnimatedPodium = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    ref: secondPodiumRef,
  });

  const thirdPodiumRef = useRef();
  const thirdAnimatedPodium = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    ref: thirdPodiumRef,
  });

  useChain([firstPodiumRef, accentRef, secondPodiumRef, thirdPodiumRef], [0, 0.5, 0.6, 0.9]);

  useEffect(() => {
    setData(
      (activeBoards !== 1 || windowSize.width <= 768)
        ? leaderboardData.slice(0, 1)
        : leaderboardData.slice(0, 3),
    );
  }, [activeBoards, leaderboardData, windowSize]);

  const animationClasses = ['firstAnimatedPodium', 'secondAnimatedPodium', 'thirdAnimatedPodium'];
  const animationStyles = [firstAnimatedPodium, secondAnimatedPodium, thirdAnimatedPodium];
  const isMinimized = activeBoards === 2 || activeBoards === 3 || windowSize.width <= 768;

  return (
    <PodiumWrapper
      activeBoards={activeBoards}
    >
      {data.map((athlete, index) => (
        <animated.div
          className={`podium-wrapper ${animationClasses[index] || ''}`}
          style={{
            ...(isMinimized ? minimizedPodiumStyles : defaultPodiumStyles),
            ...animationStyles[index],
          }}
        >
          <PodiumCard
            className='podium-card'
            athlete={athlete.userName}
            avatar={athlete.userPic}
            date={athlete.dateSet}
            place={athlete.rank}
            result={athlete.displayValue}
            small={isMinimized}
            minimized={activeBoards === 3 || windowSize.width <= 480}
          />
        </animated.div>
      ))}
    </PodiumWrapper>
  );
};

MultiplePodiums.propTypes = {
  activeBoards: PropTypes.number.isRequired,
  leaderboardData: PropTypes.instanceOf(Array).isRequired,
  windowSize: PropTypes.instanceOf(Object).isRequired,
};

export default MultiplePodiums;
